<template>
  <div class="cover">
    <div class="logo">
      <img
        src="https://s3-us01.didiglobal.com/silver-bullet-img/2024-12-26/9dD19u/DiDiCard_Primary_Logo_RGB.png"
        alt=""
      />
    </div>
    <div class="mask"></div>
  </div>
</template>
            
<script lang="ts">
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "cover",
  components: {},
});
</script>
            
<style scoped>
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.logo img {
  width: 750px;
  height: auto;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: 0.7;
  background: #0b0b0d;
  z-index: 599;
}
@media screen and (max-width: 840px) {
  .logo img {
    width: 100%;
    height: auto;
  }
}
</style>
            
          